module.exports = __webpack_public_path__ + "static/media/buenbit-logo-blue.360d50ae.svg";